import { render, staticRenderFns } from "./JsonPayloadView.vue?vue&type=template&id=e56f36ea&scoped=true&"
import script from "./JsonPayloadView.vue?vue&type=script&lang=ts&"
export * from "./JsonPayloadView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56f36ea",
  null
  
)

export default component.exports